import { useMemo } from 'react';
import { useSelector } from 'react-redux';

const getNested = (obj, path) => {
  if (!obj || !path) return undefined;
  return path.split('.').reduce((acc, part) => (acc == null ? undefined : acc[part]), obj);
};

/**
 * useCompanySetting(key, defaultValue?)
 * - key: string property name (supports dot-paths, e.g. "invoice.value")
 * - defaultValue: returned when the setting is missing (optional)
 */
export const useCompanySetting = (key, defaultValue) => {
  const settings = useSelector(state => state.company?.settings);
  return useMemo(() => {
    if (!key) return defaultValue;
    const val = getNested(settings, key);
    return val === undefined ? defaultValue : val;
  }, [settings, key, defaultValue]);
}
